import React, { StrictMode, Suspense, lazy } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider, createBrowserRouter } from 'react-router';

import { PrivateRoute } from '@src/ProtectedRoutes';

import '@tools/sentry';

import { lazyRetry } from '@helpers/common/chunk.helpers';

import Loader from '@components/common/Loader';

import { PATH_ADMIN, PATH_INDEX } from '@constants/common/routes.constants';

import App from './App';
import './index.css';

const AdminPage = lazy(() =>
  lazyRetry(() => import(/* webpackChunkName: "bridge" */ '@pages/Admin')),
);

const Bonds = lazy(() =>
  lazyRetry(
    () => import(/* webpackChunkName: "request a farm" */ '@pages/Bonds'),
  ),
);

const NotFound = lazy(() =>
  lazyRetry(
    () =>
      import(/* webpackChunkName: "not-found" */ '@components/common/NotFound'),
  ),
);

const router = createBrowserRouter([
  {
    path: PATH_INDEX,
    element: <App />,
    caseSensitive: false,
    children: [
      {
        path: PATH_INDEX,
        element: <Bonds />,
        caseSensitive: false,
      },
      {
        element: <PrivateRoute path={PATH_ADMIN} redirectPath={PATH_INDEX} />,
        children: [
          {
            path: PATH_ADMIN,
            element: <AdminPage />,
            caseSensitive: false,
          },
        ],
      },
      {
        path: '*',
        element: <NotFound />,
        caseSensitive: false,
      },
    ],
  },
]);

createRoot(document.getElementById('app')!).render(
  <StrictMode>
    <Suspense fallback={<Loader size={42} isCenter />}>
      <RouterProvider router={router} />
    </Suspense>
  </StrictMode>,
);
